import type { ReactNode } from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle: string;
  actions?: ReactNode;
  /** Compact mode for sub-pages / forms (less padding, smaller icon) */
  compact?: boolean;
}

/**
 * Premium page header with gradient background, decorative circles,
 * branded icon, title/subtitle, and optional right-side actions.
 *
 * Extracted from ProgramSettings hero pattern for reuse across all pages.
 */
export default function PageHeader({
  icon,
  title,
  subtitle,
  actions,
  compact = false,
}: PageHeaderProps) {
  return (
    <div
      className={`offers-page-header ${compact ? 'compact' : ''}`}
    >
      {/* Decorative circles */}
      <div className="offers-page-header-circle offers-page-header-circle-top" />
      <div className="offers-page-header-circle offers-page-header-circle-bottom" />

      {/* Content */}
      <div className="offers-page-header-content">
        {/* Left: icon + text */}
        <div className="offers-page-header-left">
          <div className="offers-page-header-icon">
            {icon}
          </div>

          <div className="offers-page-header-text">
            <h1 className="offers-page-header-title">{title}</h1>
            <p className="offers-page-header-subtitle">{subtitle}</p>
          </div>
        </div>

        {/* Right: actions */}
        {actions && (
          <div className="offers-page-header-actions">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
